// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"deal-like_uk-open__53dwd","grecaptcha-badge":"deal-like_grecaptcha-badge__28VLU","root":"deal-like_root__TdRwi","isLiked":"deal-like_isLiked__2TcS3","removeIcon":"deal-like_removeIcon__7OQi9"};
    if(module.hot) {
      // 1756311281520
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  